import { useState } from "react";
import { FiCopy, FiCheck } from "react-icons/fi";

export default function GroupInvite({ slug, compact = false }) {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState("");
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(new URL(`/join/group/${encodeURIComponent(slug)}`, window.location.origin).href);
      setCopied(true);
      setError("");
    } catch {
      setError("Could not copy the link. Please try again.");
    }
  };
  return <div className={`group-invite${compact ? " group-invite-inline" : ""}`}>
    <button type="button" onClick={copy} className="group-invite-button">
      {copied ? <FiCheck aria-hidden="true" /> : <FiCopy aria-hidden="true" />}{copied ? "Link copied" : "Copy invite link"}
    </button>
    {error && <p role="alert" className="mt-2 text-xs">{error}</p>}
  </div>;
}
